import type { RolePermissionMap } from "@its-engineering-and-development/rbac-react";
import { ROLE_IDENTIFIERS } from "@app/lib/role-constants";

export const PERMISSIONS = {
  EVENT_VIEW: "event:view",
  EVENT_CREATE: "event:create",
  EVENT_EDIT: "event:edit",
  EVENT_DELETE: "event:delete",
  EVENT_PUBLISH: "event:publish",
  SESSION_VIEW: "session:view",
  SESSION_CREATE: "session:create",
  SESSION_EDIT: "session:edit",
  SESSION_DELETE: "session:delete",
  ATTENDEE_VIEW: "attendee:view",
  ATTENDEE_INVITE: "attendee:invite",
  ATTENDEE_MANAGE: "attendee:manage",
  SCHEDULE_VIEW: "schedule:view",
  SCHEDULE_EDIT: "schedule:edit",
  CALENDAR_VIEW: "calendar:view",
  ORGANIZER_MANAGE: "organizer:manage",
  CLIENT_MANAGE: "client:manage",
  SETTINGS_EDIT: "settings:edit",
  POLICY_MANAGE: "policy:manage",
  DASHBOARD_VIEW: "dashboard:view",
} as const;

const organizerPermissions = [
  PERMISSIONS.EVENT_VIEW,
  PERMISSIONS.EVENT_CREATE,
  PERMISSIONS.EVENT_EDIT,
  PERMISSIONS.SESSION_VIEW,
  PERMISSIONS.SESSION_CREATE,
  PERMISSIONS.SESSION_EDIT,
  PERMISSIONS.ATTENDEE_VIEW,
  PERMISSIONS.ATTENDEE_INVITE,
  PERMISSIONS.SCHEDULE_VIEW,
  PERMISSIONS.SCHEDULE_EDIT,
  PERMISSIONS.CALENDAR_VIEW,
];

const adminPermissions = [
  ...organizerPermissions,
  PERMISSIONS.EVENT_DELETE,
  PERMISSIONS.EVENT_PUBLISH,
  PERMISSIONS.SESSION_DELETE,
  PERMISSIONS.ATTENDEE_MANAGE,
  PERMISSIONS.ORGANIZER_MANAGE,
  PERMISSIONS.CLIENT_MANAGE,
  PERMISSIONS.SETTINGS_EDIT,
  PERMISSIONS.POLICY_MANAGE,
  PERMISSIONS.DASHBOARD_VIEW,
];

export const rolePermissionMap: RolePermissionMap = {
  [ROLE_IDENTIFIERS.ORGANIZER]: organizerPermissions,
  [ROLE_IDENTIFIERS.ADMIN]: adminPermissions,
  [ROLE_IDENTIFIERS.EVENTS_ADMIN]: adminPermissions,
};
